import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { SMART_ICE_QAMUTIK } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import { getMinMaxDateFromTimeIso } from '../utility/getDateFromTimeIso'

const id = 'SmartIceQamutikLineString'
const authId = 'SmartIce'
const datetimeId = 'SmartIceQamutikLineString'
const SOURCE_URL = ({ idToken, timeIso }) =>
      `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3ASmartIceQamutikLineString&width=512&height=512&srs=EPSG:3857&format=image%2Fpng8&transparent=true&TIME=${encodeURIComponent(
    getMinMaxDateFromTimeIso({ timeIso, min: true })
  )}%2F${encodeURIComponent(
    getMinMaxDateFromTimeIso({ timeIso, max: true })
  )}&BBOX={bbox-epsg-3857}&token=${idToken}`

class SmartIceQamutikLineString extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions } = this.props
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time } = this.props
    const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''
    const rasterSource = {
      type: 'raster',
      tiles: [SOURCE_URL({ idToken, timeIso })],
      tileSize: 512
    }

    if (!visible) {
      return null
    }

    return (
      <div>
        <Source id={id} tileJsonSource={rasterSource} />
        <Layer
          type='raster'
          id={id}
          sourceId={id}
          layout={{
            visibility: visible ? 'visible' : 'none'
            // 'raster-fade-duration': 300
          }}
          paint={paint}
        />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(state, id, authId),
      paint: getPaint(state, id),
      time: state.layer.times[datetimeId] || undefined
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps(), null)(SmartIceQamutikLineString)



// WEBPACK FOOTER //
// ./src/layers/SmartIceQamutikLineString.js